import {ChangeDetectionStrategy, Component, computed, inject, Signal} from "@angular/core";
import {Page} from "../../navigation/page";
import {OrderingContextModel} from "../ordering-context.model";
import {OrderType} from '../../order/order';
import {OrderInitiationStatus, OrderModel} from '../../order/order.model';
import {ContentMessageComponent} from "../../notification/message/content-message.component";
import {MessageLevel} from "../../notification/message/message";
import {ModalPageLayoutComponent} from '../../page-layout/modal-page-layout/modal-page-layout.component';
import {SelectionFieldComponent} from '../../inputs/selection-field/selection-field.component';
import {TranslateModule} from '@ngx-translate/core';
import {ButtonComponent} from '../../buttons/button/button.component';
import {LinkComponent} from '../../buttons/link/link.component';
import {PageFooterControlDirective} from '../../page-layout/page-footer-control.directive';

@Component({
    selector: "woa-ordering-context-edit-page",
    templateUrl: "./ordering-context-edit-page.component.html",
    styleUrl: "./ordering-context-edit-page.component.scss",
    providers: [{provide: Page, useExisting: OrderingContextEditPageComponent}],
    imports: [
        ButtonComponent,
        ContentMessageComponent,
        LinkComponent,
        ModalPageLayoutComponent,
        PageFooterControlDirective,
        SelectionFieldComponent,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderingContextEditPageComponent extends Page {
    public orderingContextModel: OrderingContextModel = inject(OrderingContextModel);
    public orderModel: OrderModel = inject(OrderModel);

    OrderType = OrderType;
    MessageLevel = MessageLevel;

    public title: Signal<string> = computed(() => this.orderingContextModel.orderType() === OrderType.ORDER_AHEAD ? "woa.heading.ordering-context.order-details.orderAhead"
        : this.orderingContextModel.orderType() === OrderType.ORDER_DELIVERY ? "woa.heading.ordering-context.order-details.orderDelivery"
            : this.orderingContextModel.orderType() === OrderType.ORDER_AT_TABLE ? "woa.heading.ordering-context.order-details.orderAtTable"
                : "woa.heading.ordering-context.orderDetails");

    public storeLabel: Signal<string> = computed(() => this.orderingContextModel.orderType() === OrderType.ORDER_AHEAD ? "woa.label.ordering-context.selected-store.orderAhead"
        : this.orderingContextModel.orderType() === OrderType.ORDER_DELIVERY ? "woa.label.ordering-context.selected-store.orderDelivery"
            : this.orderingContextModel.orderType() === OrderType.ORDER_AT_TABLE ? "woa.label.ordering-context.selected-store.orderAtTable"
                : undefined);

    public confirmedAddress: Signal<string> = computed(() => this.orderingContextModel.addressTrusted() ? this.orderingContextModel.address().formattedAddress : undefined);

    public orderTime: Signal<string> = computed(() => this.orderingContextModel.expectedCompletion() ? "'" + this.orderingContextModel.formattedExpectedCompletion() + "'"
        : this.orderingContextModel.canShowAsapSelectionTime() ? "woa.label.ordering-context.asap"
            : undefined);

    public showTimeSpinner: Signal<boolean> = computed(() => !this.orderingContextModel.expectedCompletion() && this.orderingContextModel.canShowAsapSelectionTime() &&
        !this.orderingContextModel.evaluatingExpectedCompletionChange() && this.orderModel.orderInitiationStatus() === OrderInitiationStatus.INITIATING);

    public etaLabel: Signal<string> = computed(() => !this.orderingContextModel.canShowETA() || !this.orderModel.orderEta() || this.orderingContextModel.evaluatingExpectedCompletionChange() || this.orderModel.orderInitiationStatus() === OrderInitiationStatus.INITIATING ? undefined
        : this.orderingContextModel.orderType() === OrderType.ORDER_AHEAD ? "woa.label.ordering-context.eta.orderAhead"
            : "woa.label.ordering-context.eta.orderDelivery");
}
